import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import trans from 'translate';
import TokenTokenLists from '../TokenTokenLists/TokenTokenLists';

import './TokenVerifiedOnTokenLists.scss';

const TokenVerifiedOnTokenLists = ({ token, text, list, showLength, className }) => {
  const renderedList = list.length ? list : token?.verified_token_lists;
  if (token?.verified_token_lists?.length === 0) return null;

  return (
    <div className={clsx('token-verified-on-token-lists-wrapper font-reg', className)}>
      {trans(text, {
        num: showLength ? renderedList?.length : '',
        lists: <TokenTokenLists lists={renderedList} />,
      })}
    </div>
  );
};
TokenVerifiedOnTokenLists.defaultProps = {
  text: 'pools.verified_on_token_lists',
  className: '',
  list: [],
  showLength: true,
};
TokenVerifiedOnTokenLists.propTypes = {
  token: PropTypes.object.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  list: PropTypes.array,
  showLength: PropTypes.bool,
};

export default TokenVerifiedOnTokenLists;
